// extracted by mini-css-extract-plugin
module.exports = {"chart-footer":"style_chart-footer__3yMxi"};